import styled, { css } from 'styled-components';

export const LogoWrapper = styled.img`
 width: ${props => (props.width ? props.width : '')};
 height: ${props => (props.height ? props.height : '')};
`;



// WEBPACK FOOTER //
// ./src/lib/components/shared/TeamLogo/styles.js